// extracted by mini-css-extract-plugin
export default {"icon_around":"FirstPhase_icon_around__HqUlD"};